const eng = {
  common: {
    dailyLimit: 'Daily limit reached. Please come tomorrow.',
    loading: 'Loading...',
    serverError: 'Server Error',
  },
  intro: { playNow: 'Play Now', knowMore: 'Know More' },
  login: {
    fillFields: 'Please fill in all fields!',
    invalid: 'Invalid number',
    title: 'Login to start Game',
    number: 'Enter Contact Number',
    numberLabel: 'Enter the mobile number',
    numberPlaceholder: 'Mobile number',
    password: 'Enter Password',
    login: 'Login',
    subscribeLink: 'Not a user, Subscribe',
    lowbalance:
      'You have insufficient balance. Please top up your airtime and try again to access this service.',
    inprocess: 'Service charging is in process. Please wait for some time.',
    invalidNumber: 'Enter a valid phone number.',
    errorMsg: 'Something Went Wrong!',
    notSub: 'No subscription found',
  },
  register: {
    fillFields: 'Please fill in all fields!',
    title: 'Subscribe to start game',
    name: 'Enter Name',
    number: 'Enter Contact Number',
    numberLabel: 'Enter the mobile number',
    numberPlaceholder: 'Mobile number',
    password: 'Enter Password',
    subscribe: 'Subscribe',
    loginLink: 'Already a user, Login',
    dailyPass: 'Daily Pass',
    dailyDesc: '24 Hours of Games',
    weeklyPass: 'Weekly Pass',
    weeklyDesc: '7 Days of Access',
    monthlyPass: 'Monthly Pass',
    monthlyDesc: '30 Days of Games',
    privacy: 'Privacy Supplement',
    acceptPrivacy: 'Please accept the Privacy Supplement',
    paymentNote: 'Payment via Main Balance or M-Pesa',
    lowbalance:
      'You have insufficient balance. Please top up your airtime and try again to access this service.',
    inprocess: 'Service charging is in process. Please wait for some time.',
    redirect:
      'Please wait, you will be redirected to confirm your subscription',
    subSuccess:
      'You will receive a subscription confirmation message, Please confirm it. After successful subscription click on below button to access the service.',
    invalidNumber: 'Enter a valid phone number.',
    alreadySub:
      "You are already subscribed on service. To access the service, click on below 'Click Here' button",
    errorMsg: 'Something Went Wrong!',
    clickHere: 'Click Here',
    notSub: 'No subscription found',
  },
  home: { title: 'Game Levels' },
  account: {
    account_subtitle: 'Hidden Chit Game Player',
    pointText: 'Total Points',
    currentlevel: 'Current Level',
    gameprogress: 'Game Progress',
    levelprogress: 'Level Progress',
    btn: 'Unsubscribe',
    unsubTitle: 'Confirm Unsubscribe',
    unsubText:
      'Are you sure you want to unsubscribe from your current plan? You may lose access to premium games and active benefits.',
    unsubCancel: 'NO',
    unsubConfirm: 'YES',
    errorMsg: 'Something Went Wrong!',
    nameUpdated: 'Name updated successfully!',
    editProfile: 'Edit Profile',
    save: 'Save',
    cancel: 'Cancel',
    wheelSpin: 'Wheel Spin',
    locked: 'Locked',
    completeLevel10: 'Complete Level 10',
    alreadySpin: 'You already spin today',
    goHome: 'Go To Home',
    userHistory: 'User History',
  },
  level: {
    level: 'Level',
    subtitle: 'Find the correct object!',
    tapPuzzle: 'Tap to open puzzle',
    puzzleTitle: 'Puzzle',
    chooseObj: 'Now choose the correct object',
    gameOver: 'Game Over',
    usedTries: "You've used all 2 tries",
    restart: 'Restart',
    home: 'Home',
    wrong: 'Wrong! Try again',
    correct: 'Correct',
    loading: 'Loading...',
    silverUnlocked: 'Silver Chit Unlocked!',
    goldenUnlocked: 'Golden Chit Unlocked!',
    diamondUnlocked: 'Diamond Chit Unlocked!',
    exploreNow: 'Explore Now',
    claimReward: 'Claim Reward',
    timeLeft: 'Time Left',
  },
  history: {
    levelHistory: 'User Level History',
    spinHistory: 'User Spin History',
    goldenTitle: 'Golden chit Reward',
    diamondTitle: 'Diamond Chit Reward',
    noHistory: 'No history found',
    level: 'Level',
    points: 'Points',
    date: 'Date',
    riddle: 'Riddle',
    answer: 'Answer',
    spin: 'Spin',
    goldenReward: 'Golden Chit Reward',
    reward: 'Reward',
    goldenRewardLabel: 'Golden Reward',
    type: 'Type',
    diamond: 'Diamond',
    noDiamond: 'No diamond reward found',
  },
  silver: {
    wonPrize: 'Won Prize',
    clickOpen: 'Click to Open',
    opening: 'Opening...',
    spinning: 'Spinning...',
    spinWheel: 'Spin Wheel',
    youWon: 'You won',
    nextLevel: 'Next Level',
  },
  golden: { congrats: 'Congratulations!', claimPrize: 'Claim Prize' },
  diamond: {
    title: 'Diamond Archive',
    claimAll: 'Claim All Rewards',
    hint: 'Click the Diamond Envelope to Open!',
    data: 'Data',
    points: 'Points',
  },
  finish: {
    gameOver: 'GAME OVER',
    clickEnvelopes: 'Click Envelopes to Reveal Rewards',
    screenshotTip:
      'If you want a screenshot and share your winning with your friends!',
    allCollected: 'ALL COLLECTED!',
    finalText:
      'You have collected all the hidden treasures. Check your account for the total balance!',
    goAccount: 'GO TO ACCOUNT',
    toolLoading: 'Tool still loading...',
    victory: 'Victory!',
    shareText: 'I won big in Hidden Chit Game!',
  },
  levelMap: {
    subHeader: 'Complete all 50 levels and unlock rewards!',
    silver: 'Silver Chit',
    golden: 'Golden Chit',
    diamond: 'Diamond Chit',
    trophy: 'Trophy',
  },
};

export default eng;
